var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"value":!_vm.online,"type":"error","transition":"scale-transition"}},[_vm._v(" "+_vm._s(_vm.$t('base.offline'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }